import Vue from 'vue';
import app from 'app';
import 'typed';
/**
 *  spectrum Vue directive
 */
Vue.directive('spectrum', {
  inserted: function (el, binding) {
    const $el = $(el);
    const color = tinycolor(binding.value.defaultValue || '#000');

    $el.spectrum({
      color: color,
      showAlpha: true,
      preferredFormat: 'hex',
      showInput: true,
      hideAfterPaletteSelect: true,
      showPalette: true,
      showPaletteOnly: !binding.value.enableColorPicker,
      showSelectionPalette: true,
      localStorageKey: 'spectrum.op',
      palette: _.chunk(binding.value.options, 5),
      change: (($el) => {
        return (color) => {
          $el.val(color);

          if (_.isFunction(binding.value.onChange)) {
            const value = color.toHex8();
            binding.value.onChange(value);
          }
        };
      })($el),
    });
  },

  unbind: function (el) {
    // wait until a possible transition end to destroy spectrum
    setTimeout(() => {
      $(el).spectrum('destroy');
    }, 500);
  },
});

/**
 * override bootstrap 3.4.1 tooltip destroy function
 * adding proper safety checks
 */
app.$.fn.tooltip.Constructor.prototype.destroy = function () {
  clearTimeout(this.timeout);
  this.hide(() => {
    if (this.$element) {
      this.$element.off('.' + this.type).removeData('bs.' + this.type);
    }
    if (this.$tip) {
      this.$tip.detach();
    }
    this.$tip = null;
    this.$arrow = null;
    this.$viewport = null;
    this.$element = null;
  });
};

/**
 *  bootstrap tooltip Vue directive
 *  @link https://getbootstrap.com/docs/3.3/javascript/#tooltips
 */
Vue.directive('tooltip', {
  inserted: function (el, binding, vnode) {
    if (binding.modifiers.extend) {
      vnode.context.$_tooltipHandler = (command) => {
        $(el).tooltip(command);
      };

      vnode.context.$_updateTooltipTitle = (title) => {
        $(el).attr('data-original-title', title);
      };
    }

    binding.def._initTooltip(el, binding);
  },

  _initTooltip(el, binding) {
    const wrapperClass = binding.value.wrapperClass || '';
    const template = `
<div class="wt2-sg tooltip wt-preset-tooltip ${wrapperClass}" role="tooltip">
    <div class="tooltip-arrow"></div>
    <div class="tooltip-inner"></div>
</div>`.normalizeSpace();

    $(el).tooltip({
      placement: binding.value.placement || 'left',
      selector: binding.value.selector || undefined,
      html: binding.value.html,
      viewport: binding.value.viewport,
      container: binding.value.container || '.wt-body',
      animation: _.isDefined(binding.value.animation)
        ? binding.value.animation
        : true,
      delay: _.isDefined(binding.value.delay) ? binding.value.delay : 750,
      title: binding.value.title,
      trigger: binding.value.trigger || 'hover',
      template,
    });
  },

  unbind: function (el, binding, vnode) {
    $(el).tooltip('destroy');
    vnode.context.$_tooltipHandler = null;
    vnode.context.$_updateTooltipTitle = null;
    vnode.context = null;
    binding.value = null;
    $('.wt-body').find('.wt-preset-tooltip').remove();
  },

  update: function (el, binding) {
    const tip = $(el).data('bs.tooltip');

    tip.options.title = binding.value.title;

    if (!binding.value.title && tip.enabled) {
      $(el).tooltip('hide');
      $(el).tooltip('disable');
    } else if (binding.value.title && !tip.enabled) {
      $(el).tooltip('enable');
    }
  },
});

/**
 *  pulse Vue directive
 *
 *  binding.value: {
 *     rate: the pulse rate - should be between 0 - 100
 *     minRate: (Optional) - the min rate to display even if rate is lower (in px)
 *     maxRate: (Optional) - the max rate to display even if rate is higher (in px)
 *     isActive: (Optional) - activate/deactivate the pulse
 *     color: (Optional) - the color of the pulse
 *  }
 */
Vue.directive('pulse', {
  update: function (el, binding) {
    const obj = $.extend(
      {
        rate: 0,
        minRate: 0,
        maxRate: 100,
        isActive: false,
        color: 'rgba(0, 0, 0, 0.1)',
      },
      binding.value
    );

    if (!obj.isActive) {
      return;
    }

    let rate = (obj.maxRate / 100) * obj.rate;

    if (rate < obj.minRate) {
      rate = obj.minRate;
    }

    el.style.boxShadow = `0 0 0 ${rate}px ${obj.color}`;
  },

  unbind: function (el) {
    el.style.boxShadow = 'none';
  },
});

/**
 *  copy Vue directive
 */
const copyHandler = (el) => {
  if (el.select) {
    el.select();
  } else {
    const selection = window.getSelection();
    const range = document.createRange();
    range.selectNodeContents(el);
    selection.removeAllRanges();
    selection.addRange(range);
  }
  document.execCommand('copy');
};
let copyHandlerBound = null;

Vue.directive('copy', {
  bind: function (el) {
    copyHandlerBound = copyHandler.bind(null, el);
    el.addEventListener('dblclick', copyHandlerBound);
  },
  unbind: function (el) {
    if (copyHandlerBound) {
      el.removeEventListener('dblclick', copyHandlerBound);
      copyHandlerBound = null;
    }
  },
});

/**
 *  text-right Vue directive
 *
 *  example:
 *     <span v-text-right="{ animateSpeed: 10 }">text that with overflow of the parent/span>
 */
Vue.directive('text-right', {
  _hasTextOverflow(el) {
    return el.scrollWidth > el.clientWidth;
  },

  _animate(animateSpeed) {
    this.scrollLeft += animateSpeed;

    if (this.scrollWidth >= this.scrollLeft) {
      this._currentAnimation = requestAnimationFrame(this._animateFrame);
    }
  },

  _onMouseEnter(def, animateSpeed) {
    this.style.textOverflow = 'unset';
    this._animateFrame = def._animate.bind(this, animateSpeed);
    this._currentAnimation = requestAnimationFrame(this._animateFrame);
  },

  _onMouseLeave() {
    this.style.textOverflow = 'ellipsis';
    this.scrollLeft = 0;
    cancelAnimationFrame(this._currentAnimation);
  },

  _noListenersAttached(el) {
    return !el._mouseEnter && !el._mouseLeave;
  },

  componentUpdated(el, binding) {
    const options = Object.assign(
      {
        animateSpeed: 1,
      },
      binding.value || {}
    );
    // unset scrollLeft if componentUpdated,
    // usually means no _onMouseLeave was called (ie: click event closes dropdown)
    el.scrollLeft = 0;

    if (
      binding.def._noListenersAttached(el) &&
      binding.def._hasTextOverflow(el)
    ) {
      // set three dots on element
      el.style.whiteSpace = 'nowrap';
      el.style.overflow = 'hidden';
      el.style.textOverflow = 'ellipsis';
      // bind events on parent element
      el._mouseEnter = binding.def._onMouseEnter.bind(
        el,
        binding.def,
        options.animateSpeed
      );
      el.parentElement.addEventListener('mouseenter', el._mouseEnter);
      el._mouseLeave = binding.def._onMouseLeave.bind(el);
      el.parentElement.addEventListener('mouseleave', el._mouseLeave);
    }
  },

  unbind(el) {
    el.parentElement.removeEventListener('mouseenter', el._mouseEnter);
    el.parentElement.removeEventListener('mouseleave', el._mouseLeave);
  },
});

/**
 *  animate-sequence
 *
 *  example:
 *     <span v-animate-sequence="{ animateInterval: 500  }">...</span>
 */
Vue.directive('animate-sequence', {
  _animate(el, animateInterval, timestamp) {
    if (el._animateIntervalStart === 0) {
      el._animateIntervalStart = timestamp;
    }

    if (el._animateTextIndex === el._originalText.length + 1) {
      el._animateTextIndex = 0;
    }

    const progress = timestamp - el._animateIntervalStart;
    el._currentAnimation = requestAnimationFrame(el._animateFrame);

    if (progress >= animateInterval) {
      el._animateIntervalStart = 0;
      el.textContent = el._originalText.substr(0, el._animateTextIndex);
      el._animateTextIndex += 1;
    }
  },

  bind(el, binding) {
    const options = Object.assign(
      {
        animateInterval: 250,
      },
      binding.value || {}
    );

    el._originalText = el.textContent;
    el._animateIntervalStart = 0;
    el._animateTextIndex = 0;

    el._animateFrame = binding.def._animate.bind(
      null,
      el,
      options.animateInterval
    );
    el._currentAnimation = requestAnimationFrame(el._animateFrame);
  },

  componentUpdated(el, binding) {
    const options = Object.assign(
      {
        cancelAnimation: false,
      },
      binding.value || {}
    );

    if (options.cancelAnimation) {
      cancelAnimationFrame(el._currentAnimation);
      el.textContent = el._originalText;
      el._animateIntervalStart = 0;
      el._animateTextIndex = 0;
    }
  },

  unbind(el) {
    cancelAnimationFrame(el._currentAnimation);
  },
});

Vue.directive('click-outside', {
  bind: function (el, binding, vNode) {
    // Provided expression must evaluate to a function.
    if (typeof binding.value !== 'function') {
      const compName = vNode.context.name;
      let warn = `[Vue-click-outside:] provided expression '${binding.expression}' is not a function, but has to be`;
      if (compName) {
        warn += `Found in component '${compName}'`;
      }
      console.warn(warn);
    }
    // Define Handler and cache it on the element
    const bubble = binding.modifiers.bubble;
    const handler = (e) => {
      if (
        bubble ||
        (document.contains(e.target) &&
          el &&
          !el.contains(e.target) &&
          el !== e.target)
      ) {
        binding.value(e);
      }
    };
    el.__vueClickOutside__ = handler;

    // add Event Listeners
    document.addEventListener('click', handler);
  },

  unbind: function (el) {
    // Remove Event Listeners
    document.removeEventListener('click', el.__vueClickOutside__);
    el.__vueClickOutside__ = null;
  },
});

/**
 *  typed Vue directive
 */
Vue.directive('typed', {
  inserted(el, binding) {
    $(el).typed({
      strings: binding.value.strings,
      loop: binding.value.loop || false,
      typeSpeed: binding.value.typeSpeed || 0,
    });
  },
});

/**
 *  tab-guard Vue directive
 *
 *  example:
 *  <div v-tab-guard>
 *      <div tabindex="0"></div>
 *      <div tabindex="-1"></div>
 *      <div tabindex="-1"></div>
 *      <div tabindex="-1"></div>
 *  </div>
 */
Vue.directive('tab-guard', {
  _setNextFocusElement(e, el, direction) {
    e.preventDefault();
    el.classList.add('enable-focus');

    // there can be only one!
    const currFocusElement = el.querySelector('[tabindex="0"]');

    // set the first element to focus if there are no tabindex="0"
    if (!currFocusElement) {
      const firstElementNotFocused = el.querySelector('[tabindex="-1"]');

      if (firstElementNotFocused) {
        firstElementNotFocused.setAttribute('tabindex', '0');
        firstElementNotFocused.focus();
      } else {
        console.warn(
          'v-tab-guard: directive is activated but there is no tabindex on any element!'
        );
      }

      return; // exit function if currFocusElement is null
    }

    let curElementNextSibling =
      direction === 'forward'
        ? currFocusElement.nextElementSibling
        : currFocusElement.previousElementSibling;

    while (curElementNextSibling !== null) {
      const tabIndex = curElementNextSibling.getAttribute('tabindex');

      if (tabIndex && tabIndex === '-1') {
        currFocusElement.setAttribute('tabindex', '-1');
        curElementNextSibling.setAttribute('tabindex', '0');
        curElementNextSibling.focus();
        return; // break loop
      } else {
        curElementNextSibling =
          direction === 'forward'
            ? curElementNextSibling.nextElementSibling
            : currFocusElement.previousElementSibling;
      }
    }

    // if current element is still focused, it means
    // we have reached the end or start of the list
    if (currFocusElement.getAttribute('tabindex') === '0') {
      const allTabIndexElements = el.querySelectorAll('[tabindex="-1"]');

      if (allTabIndexElements && allTabIndexElements.length) {
        const tabToFocus =
          direction === 'forward'
            ? allTabIndexElements[0]
            : allTabIndexElements[allTabIndexElements.length - 1];

        currFocusElement.setAttribute('tabindex', '-1');
        tabToFocus.setAttribute('tabindex', '0');
        tabToFocus.focus();
      } else {
        // there are only tabindex="0", set all but the first to tabindex="-1"
        const allTabIndexElements = el.querySelectorAll('[tabindex="0"]');

        allTabIndexElements.forEach((element, index) => {
          if (index === 0) {
            element.focus();
          } else {
            element.setAttribute('tabindex', '-1');
          }
        });
      }
    }
  },

  _isActivated(val) {
    return _.isObject(val) && _.isDefined(val.activated) ? val.activated : true;
  },

  bind(el, binding) {
    el.__vueTabGuardGuid__ = app.guid();

    if (binding.def._isActivated(binding.value)) {
      // on init, set tabindex="0" to focus
      const currFocusElement = el.querySelector('[tabindex="0"]');

      if (currFocusElement) {
        // wait for next tick so that element will be in dom, and then focus
        Vue.nextTick(() => {
          currFocusElement.focus();
        });
      } else {
        console.warn(
          'v-tab-guard: there is no initial tabindex="0" in the list!'
        );
      }
    }

    const handlers = [
      {
        on: 'keydown',
        key: $.ui.keyCode.TAB,
        run: (e) => {
          if (binding.def._isActivated(binding.value)) {
            binding.def._setNextFocusElement(e, el, 'forward');
          }
        },
      },
      {
        on: 'keydown',
        key: $.ui.keyCode.TAB,
        shiftKey: true,
        run: (e) => {
          if (binding.def._isActivated(binding.value)) {
            binding.def._setNextFocusElement(e, el, 'backward');
          }
        },
      },
    ];

    app.keyboardAccessibility.add(
      `wt-directive-tab-guard-${el.__vueTabGuardGuid__}`,
      handlers
    );
  },

  unbind: function (el) {
    app.keyboardAccessibility.remove(
      `wt-directive-tab-guard-${el.__vueTabGuardGuid__}`
    );
  },
});

/**
 *  single-double-click Vue directive
 */
Vue.directive('single-double-click', {
  _emit(listeners, name, e) {
    listeners && listeners[name] && listeners[name].call(null, e);
  },

  bind(el, binding, vnode) {
    const options = Object.assign(
      {
        timeout: 200,
        waitForDbl: false,
      },
      binding.value || {}
    );
    el.__WT_SDC_CLICKS__ = 0;
    const listeners = vnode.data.on;

    el.__WT_SDC_FN__ = (e) => {
      e.preventDefault();
      el.__WT_SDC_CLICKS__++;

      if (!options.waitForDbl) {
        el.__WT_SDC_CLICKS__ = 0;
        binding.def._emit(listeners, 'single-click', e);
        return;
      }

      if (el.__WT_SDC_CLICKS__ > 1) {
        clearTimeout(el.__WT_SDC_TIMEOUT_ID__);
        el.__WT_SDC_CLICKS__ = 0;
        binding.def._emit(listeners, 'double-click', e);
        return;
      }

      el.__WT_SDC_TIMEOUT_ID__ = setTimeout(() => {
        binding.def._emit(listeners, 'single-click', e);
        el.__WT_SDC_CLICKS__ = 0;
      }, options.timeout);
    };

    el.addEventListener('click', el.__WT_SDC_FN__, false);
  },

  unbind: function (el) {
    clearTimeout(el.__WT_SDC_TIMEOUT_ID__);
    el.__WT_SDC_CLICKS__ = 0;
    el.removeEventListener('click', el.__WT_SDC_FN__, false);
  },
});

(function () {
  function emit(el, binding) {
    if (typeof binding.value === 'function') {
      binding.value(el);
    }
  }

  Vue.directive('el-resize', {
    // When the bound element is inserted into the DOM...
    inserted(el, binding) {
      if (window.ResizeObserver && !el.__RO) {
        el.__RO = new ResizeObserver((entries) => {
          for (const entry of entries) {
            emit(entry.target, binding);
          }
        });
        el.__RO.observe(el);
        emit(el, binding);
      }
    },

    unbind(el) {
      if (el.__RO) {
        el.__RO.unobserve(el);
        el.__RO = null;
      }
    },
  });
})();

Vue.directive('select-on-click', {
  bind(el) {
    el.__SELECT_ON_CLICK_FN = function (e) {
      e.target.setSelectionRange(0, -1);
    };
    el.addEventListener('click', el.__SELECT_ON_CLICK_FN);
  },

  unbind(el) {
    el.removeEventListener('click', el.__SELECT_ON_CLICK_FN);
  },
});

// @link https://blog.logrocket.com/building-a-long-press-directive-in-vue-3408d60fb511
Vue.directive('longpress', {
  bind: function (el, binding, vNode) {
    // Make sure expression provided is a function
    if (typeof binding.value !== 'function') {
      // Fetch name of component
      const compName = vNode.context.name;
      // pass warning to console
      let warn = `[longpress:] provided expression '${binding.expression}' is not a function, but has to be`;
      if (compName) {
        warn += `Found in component '${compName}' `;
      }

      console.warn(warn);
    }

    // Define variable
    let pressTimer = null;

    // Define funtion handlers
    // Create timeout ( run function after 1s )
    const start = (e) => {
      if (e.type === 'click' && e.button !== 0) {
        return;
      }

      if (pressTimer === null) {
        pressTimer = setInterval(() => {
          // Run function
          handler(e);
        }, app.TIME.FRAME._30 * 1000);
      }
    };

    // Cancel Timeout
    const cancel = (e) => {
      // Check if timer has a value or not
      if (pressTimer !== null) {
        clearTimeout(pressTimer);
        pressTimer = null;
      }
    };
    // Run Function
    const handler = (e) => {
      binding.value(e);
    };

    // Add Event listeners
    el.addEventListener('mousedown', start);
    el.addEventListener('touchstart', start);
    // Cancel timeouts if this events happen
    el.addEventListener('click', cancel);
    el.addEventListener('mouseout', cancel);
    el.addEventListener('touchend', cancel);
    el.addEventListener('touchcancel', cancel);
  },
});

/**
 * @example:
 * v-console-log:optional-label="someVariable"
 */
Vue.directive('console-log', {
  bind(el, binding) {
    const clean = JSON.parse(JSON.stringify(binding.value));
    console.log(`⏩️${binding.arg ? binding.arg : ''}`, clean);
  },
  update(el, binding) {
    const clean = JSON.parse(JSON.stringify(binding.value));
    console.log(`🔄${binding.arg ? binding.arg : ''}`, clean);
  },
});
